<template>
  <div>
    <div class="head">
      <div class="head-top">
        <div class="zuocelogo">
          <img style="width:594px" src="../assets/home/zuocelogo.png" alt="">
        </div>
        <div class="head-info">
          <span>时间：2026年6月2-4日</span>
          <span>地点：北京中国国际展览中心（朝阳馆）</span>
          <div @click="langchange1()" class="ignore zywqh"><img style="width:20px" src="../assets/index/English.png" alt="">English</div>
        </div>
      </div>
      <div class="head-bottom">
        <div class="caidan">
          <el-menu class="menu" :default-active="page" @select="handleOpen" mode="horizontal">
            <el-menu-item index="1"><span class="menu-text">首页</span></el-menu-item>
            <el-menu-item index="2"><span class="menu-text">展会介绍</span></el-menu-item>
            <el-menu-item index="4"><span class="menu-text">展商中心</span></el-menu-item>
            <el-menu-item index="9"><span class="menu-text">数据中心</span></el-menu-item>
            <el-menu-item index="8"><span class="menu-text">观众中心</span></el-menu-item>
            <el-menu-item index="3"><span class="menu-text">新闻中心</span></el-menu-item>
            <el-menu-item index="6" @click="cfdh"><span class="menu-text">同期活动</span></el-menu-item>
            <el-menu-item index="10"><span class="menu-text">媒体中心</span></el-menu-item>
            <el-menu-item index="11" @click="openOnlineExhibition"><span class="menu-text">线上展会</span></el-menu-item>
            <el-menu-item index="5"><span class="menu-text">交通住宿</span></el-menu-item>
            <el-menu-item index="12"><span class="menu-text">下载中心</span></el-menu-item>
            <el-menu-item index="7"><span class="menu-text">联系我们</span></el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
    <div class="cebl" v-if="false">
      <div @click="tqhd" class="cblbox">
        <img src="../assets/home/tongqihuodong.png" alt="">
        <div class="cblwz">同期活动</div>
      </div>
      <div @mouseenter="zsimg('1')" @mouseleave="zsimg()" class="cblbox">
        <img v-if="showimg==1" style="position: absolute;width:100px;right:65px;top:50px" src="../assets/home/20190911065538.png" alt="">
        <img src="../assets/home/guanzhuwomen.png" alt="">
        <div class="cblwz">关注我们</div>
      </div>
      <div @mouseenter="zsimg('2')" @mouseleave="zsimg()" class="cblbox">
        <img v-if="showimg==2" style="position: absolute;width:100px;right:65px;top:110px" src="../assets/home/zxzx.jpg" alt="">
        <img src="../assets/home/zaixianzixun.png" alt="">
        <div class="cblwz">在线咨询</div>
      </div>
      <div class="backTop" @click="backTop">
        <img src="../assets/home/xiangshang.png" alt="">
      </div>

    </div>
    <Index @childFn="parentFn" v-if="page === '1'" />
    <Gyzh :data="pageNum" :nametitle="title" v-if="page === '2'" />
    <Xwzx v-if="page === '3'" />
    <Zszx v-if="page === '4'" />
    <Ptfw v-if="page === '5'" />
    <Lxwm v-if="page === '7'" />
    <Gzzx v-if="page === '8'" />
    <Sjzx v-if="page === '9'" />
    <!-- <Wjhg @childFn="backTop" :data2="pageNum" v-if="page === '8'" /> -->
    <Zsdj @childFn="backTop" v-if="page === '13'" />
    <Mc v-if="page === '10'" />
    <Xszh v-if="page === '11'" />
    <Xzzx v-if="page === '12'" />
    <Bottom @childFn="parentFnbot" />
  </div>

</template>

<script>
import Bottom from './bottom.vue'
import Gyzh from '../components/caidan/gyzh.vue'
import Index from '../components/index.vue'
import Xwzx from '../components/caidan/xwzx.vue'
import Zszx from '../components/caidan/zszx.vue'
import Ptfw from '../components/caidan/ptfw.vue'
import Lxwm from '../components/caidan/lxwm.vue'
import Wjhg from '../components/caidan/wjhg.vue'
import Zsdj from '../components/caidan/zsdj.vue'
import Gzzx from '../components/caidan/gzzx.vue'
import Sjzx from '../components/caidan/sjzx.vue'
import Mc from '../components/caidan/mc.vue'
import Xszh from '../components/caidan/xszh.vue'
import Xzzx from '../components/caidan/xzzx.vue'

export default {
  name: 'Head',
  components: {
    Gyzh,
    Index,
    Xwzx,
    Bottom,
    Zszx,
    Ptfw,
    Lxwm,
    Wjhg,
    Zsdj,
    Gzzx,
    Sjzx,
    Mc,
    Xszh,
    Xzzx
  },
  data () {
    return {
      page: '1',
      pageNum: '',
      title: '',
      scrollTop: 0,
      showimg: ''
      // language: 'chinese_simplified'
    }
  },
  // watch: {
  //   // 监听message的变化
  //   language (newVal, oldVal) {
  //     this.language = newVal
  //   }
  // },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
  },
  // created () {
  //   console.log(this.language)
  //   var query = this.$route.params
  //   if (query.languageindex === '1') {
  //     window.translate.changeLanguage('chinese_simplified')
  //     window.translate.listener.start()
  //     window.translate.service.use('client.edge')
  //     window.translate.execute()
  //     this.language = 'chinese_simplified'
  //   } else if (query.languageindex === '2') {
  //     window.translate.changeLanguage('english')
  //     window.translate.listener.start()
  //     window.translate.service.use('client.edge')
  //     window.translate.execute()
  //     this.language = 'english'
  //     return
  //   }

  //   this.langchange2()

  //   // else if (window.translate.language.getCurrent() === 'chinese_simplified') {
  //   //   this.language = 'chinese_simplified'
  //   //   window.translate.changeLanguage('chinese_simplified')
  //   //   window.translate.listener.start()
  //   //   window.translate.service.use('client.edge')
  //   //   window.translate.execute()
  //   // }
  // },
  beforeDestroy () {

  },
  destroyed: function () {
    window.removeEventListener('scroll', this.scrollToTop)
  },

  methods: {
    langchange1 () {
      // window.translate.changeLanguage('english')
      // window.translate.listener.start()
      // window.translate.service.use('client.edge')
      // window.translate.execute()
      // this.language = 'english'
      this.$router.replace({ name: 'Headeng' })
    },
    langchange2 () {
      // this.language = 'chinese_simplified'
      // window.translate.changeLanguage('chinese_simplified')
      // window.translate.listener.start()
      // window.translate.service.use('client.edge')
      // window.translate.execute()
      this.$router.replace({ name: 'Head' })
    },
    handleOpen (key) {
      if (key === '6') {
        this.page = '1'
      } else {
        this.page = key
      }
      console.log(this.page)
      this.pageNum = ''
      this.title = ''
    },
    parentFn (params1, params2, params3) {
      this.page = params1
      this.pageNum = params2
      this.title = params3
      this.backTop()
    },
    parentFnbot (params1, params2, params3) {
      this.page = params1
      this.pageNum = params2
      this.title = params3

      this.backTop()
    },
    cfdh () {
      window.open('http://www.caepi.org.cn/cidepi/', '_blank')
    },
    tqhd () {
      window.open('http://www.caepi.org.cn/cidepi/', '_blank')
    },
    backTop () {
      const that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      const that = this
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 60) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
    },
    zsimg (index) {
      this.showimg = index
    },
    openOnlineExhibition () {
      this.$alert('该功能正在维护中，敬请期待！', '提示', {
        confirmButtonText: '确定',
        type: 'info',
        center: true
      })
    }

  }
}
</script>
<style scoped>
.cblbox {
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px dashed #eee;
}
.backTop {
  /* height: 40px; */
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  cursor: pointer;
}
.cblwz {
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
}
.cebl {
  padding: 10px 5px;
  position: fixed;
  right: 5px;
  bottom: 40%;
  text-align: center;
  width: 50px;
  background-image: linear-gradient(180deg, #0f9c77 17%, #0c68a3 100%);
  border-radius: 4px 0px 0px 4px;
}
body {
  padding: 0;
  margin: 0 !important;
}
.menu {
  border: none !important;
}
.head {
  width: 100%;
}
.head-top {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 88px;
  width: 100%;
  background-color: #fff;
  gap: 30px;
}
.head-bottom {
  width: 100%;
  background-color: #0c68a3;
  border-top: none;
  border-bottom: none;
}
.zuocelogo {
  width: 594px;
}
.caidan {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #0c68a3;
  padding: 0;
  margin: 0;
}
.head-info {
  display: flex;
  align-items: center;
  gap: 20px;
  padding-right: 20px;
  color: #475569;
}
.head-info span {
  margin-right: 20px;
}
.zywqh {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.menu {
  height: 60px !important;
  line-height: 60px !important;
  text-align: center !important;
}

.el-menu {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
  height: 60px !important;
  line-height: 60px !important;
}

.el-menu--horizontal {
  text-align: center !important;
  display: flex !important;
  justify-content: center !important;
  width: 100% !important;
}

.menu.el-menu.el-menu--horizontal {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
  width: 100% !important;
  height: 60px !important;
  line-height: 60px !important;
  box-sizing: border-box !important;
}

.menu.el-menu.el-menu--horizontal .el-menu-item {
  font-size: 15px !important;
  color: #ffffff !important;
  letter-spacing: 0 !important;
  font-weight: 500 !important;
  white-space: nowrap !important;
  padding: 0 15px !important;
  text-align: center !important;
  height: 60px !important;
  line-height: 60px !important;
  display: inline-block !important;
  vertical-align: middle !important;
  box-sizing: border-box !important;
}

/* 专门针对文字包装器的样式 */
.menu.el-menu.el-menu--horizontal .el-menu-item span.menu-text {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% !important;
  height: 100% !important;
  text-align: center !important;
  box-sizing: border-box !important;
  margin: 0 auto !important;
  padding: 0 !important;
  position: static !important;
  transform: none !important;
}

/* 确保Element UI生成的内部容器不影响居中 */
.menu.el-menu.el-menu--horizontal .el-menu-item__content,
.menu.el-menu.el-menu--horizontal .el-menu-item__title {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  width: 100% !important;
  height: 100% !important;
  text-align: center !important;
  box-sizing: border-box !important;
  margin: 0 auto !important;
  padding: 0 !important;
  position: static !important;
  transform: none !important;
}
.el-menu-item:hover {
  background-color: #0f9c77 !important;
}
.el-menu-item.is-active {
  background-color: #0f9c77 !important;
}
.menu {
  width: 100%;
  background-color: #0c68a3 !important;
  border-bottom: none !important;
  border-right: none !important;
  border-left: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/head.vue